// extracted by mini-css-extract-plugin
module.exports = {"Banner":"style-module--Banner--2YyDj","Text":"style-module--Text--30VfW"};